// src/pages/FindSwap.tsx
import React, { useState } from "react";
import "../css/Lp2App.css";
import styles from "./FindSwap.module.css"; // if you have it
import { getOrCreateUser } from "../api/usersClient";
import { setUserContext, USER_EMAIL_KEY, USER_POSTCODE_KEY } from "../utils/userContext";

// NOTE: Replace this with your actual search call / component logic
// This file shows where to persist userId once.

const FindSwap: React.FC = () => {
  const [email, setEmail] = useState<string>(localStorage.getItem(USER_EMAIL_KEY) || "");
  const [postcode, setPostcode] = useState<string>(localStorage.getItem(USER_POSTCODE_KEY) || "");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onContinue = async () => {
    setError("");

    const e = email.trim();
    const p = postcode.trim();

    if (!e) {
      setError("Email is required.");
      return;
    }

    setBusy(true);
    try {
      // ✅ Create / resolve user, get a userId
      const u = await getOrCreateUser(e, p || null);

      // ✅ Persist for the entire app (BootDetail will now have userId)
      setUserContext(u.userId, e, p);

      // TODO: continue your existing flow here:
      // - navigate to /boots or run search, etc.
      // Example:
      // navigate("/boots");
    } catch (err: any) {
      setError(err?.message || "Failed to start.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lp2__page">
      <main className="lp2__container">
        <h1 className="lp2__h1">Find a swap</h1>

        {error && <div className="lp2__error">{error}</div>}

        <div className="lp2__card" style={{ marginTop: 16 }}>
          <label className="lp2__label">Email</label>
          <input
            className="lp2__input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
          />

          <label className="lp2__label" style={{ marginTop: 12 }}>
            Postcode (optional)
          </label>
          <input
            className="lp2__input"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
            placeholder="CO1 1AA"
            autoComplete="postal-code"
          />

          <button
            type="button"
            className="lp2__btn"
            onClick={onContinue}
            disabled={busy}
            style={{ marginTop: 16 }}
          >
            {busy ? "Please wait…" : "Continue"}
          </button>
        </div>
      </main>
    </div>
  );
};

export default FindSwap;